import DropdownItem from '@atlaskit/dropdown-menu/dropdown-menu-item';
import DropdownItemGroup from '@atlaskit/dropdown-menu/dropdown-menu-item-group';
import type { DropdownItemProps } from '@atlaskit/dropdown-menu/types';
import { FormattedMessage } from 'react-intl';
import { type JSX } from 'react/jsx-runtime';

/*--Why am I seeing this--*/

type WhyAmISeeingThisProps = Omit<DropdownItemProps, 'children'>;

export const WhyAmISeeingThis = (props: WhyAmISeeingThisProps): JSX.Element => (
	<DropdownItem {...props}>
		<FormattedMessage
			id="switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label"
			defaultMessage="Why am I seeing this?"
			description="The text for the button which opens a modal showing the reasons a recommendation has been made. https://hello.atlassian.net/l/cp/ssoqm2Fq"
		/>
	</DropdownItem>
);

/*--Not interested--*/

type NotInterestedProps = Omit<DropdownItemProps, 'children'>;

export const NotInterested = (props: NotInterestedProps): JSX.Element => (
	<DropdownItem {...props}>
		<FormattedMessage
			id="switcher.ad-controls.dropdown-item.not-interested.label"
			defaultMessage="Not interested"
			description="The text for the button which removes an app from the recommendations list. https://hello.atlassian.net/l/cp/ssoqm2Fq"
		/>
	</DropdownItem>
);

type AppSwitcherDropdownProps = {
	onWhyAmISeeingThis: (
		e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
	) => void;
	onNotInterested: (
		e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
	) => void;
};

export const AppSwitcherDropdown = ({
	onWhyAmISeeingThis,
	onNotInterested,
}: AppSwitcherDropdownProps): JSX.Element => (
	<DropdownItemGroup>
		<NotInterested onClick={onNotInterested} />
		<WhyAmISeeingThis onClick={onWhyAmISeeingThis} />
	</DropdownItemGroup>
);
